import { render, staticRenderFns } from "./modalAddGroup.vue?vue&type=template&id=8972959c"
import script from "./modalAddGroup.vue?vue&type=script&lang=js"
export * from "./modalAddGroup.vue?vue&type=script&lang=js"
import style0 from "./modalAddGroup.vue?vue&type=style&index=0&id=8972959c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports